<template>
    <div v-if="errors" class="alert alert-danger" role="alert">
        <div v-for="(v, k) in errors" :key="k">
            <p v-for="error in v" :key="error">
                {{ $trans.get('__JSON__.' + error) }}
            </p>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col">
            <div class="card shadow" style="z-index: 10">
                <div class="card-body vacation-request row">
                    <div class="col-1 mt-2 mb-2">
                        <WizardSteps :step="switch_years == 'on' ? step : (step - 1)"
                            :steps="switch_years == 'on' ? 4 : 3" />
                    </div>
                    <div class="col-11 mt-2 mb-2">
                        <div class="row">
                            <div class="row p-0 m-0" v-if="switch_years == 'on'">
                                <h3 class="d-inline">Jahreswahl</h3>
                                <div class="col m-0 ml-3 p-0 form-inline switch-years">
                                    <div>
                                        <span @click="setStartYear">{{ show_year }}</span>
                                    </div>
                                    <div class="form-check form-switch form-inline">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            id="flexSwitchCheckDefault" v-model="year_switch">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">{{
                                            (parseInt(show_year) + 1) }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="step > 1" class="col-2 vacationrequestselection"
                                :class="{'mt-5': switch_years != 'off'}">
                                <h3>Abwesenheitstyp</h3>
                                <div v-if="vacationdata"
                                    :class="{'notavailable': absencetypesavailable.vacationdays + vacationdata.afterContractDays <= 0}">
                                    <button class="btn" id="btnVacation"
                                        :class="{'active': selectedAbsenceType == 'vacation', 'notavailable': absencetypesavailable.vacationdays + vacationdata.afterContractDays <= 0}"
                                        :disabled="absencetypesavailable.vacationdays + vacationdata.afterContractDays <= 0"
                                        @click.stop="changeVacationType('vacation')">
                                        <span class="material-symbols-outlined"> beach_access </span>
                                    </button>
                                    <span class="vacation-name">Urlaub</span>
                                    <span v-tooltip
                                        :title="absencetypesavailable.vacationdays + ' ' + $trans.get('__JSON__.days available')"
                                        v-if="absencetypesavailable.vacationdays + vacationdata.afterContractDays <= 0"
                                        class="material-symbols-outlined"> info </span>
                                </div>

                                <div :class="{'notavailable': absencetypesavailable.special_leave > 2}">
                                    <button class="btn" id="btnSpecialVacation"
                                        :class="{'active': selectedAbsenceType == 'special_leave', 'notavailable': absencetypesavailable.special_leave > 2}"
                                        :disabled="absencetypesavailable.special_leave > 2"
                                        @click.stop="changeVacationType('special_leave')">
                                        <span class="material-symbols-outlined"> star_rate </span>
                                    </button>
                                    <span class="vacation-name">Sonderurlaub</span>
                                    <span v-tooltip title="Keine weiteren Sonderurlaubstage in diesem Jahr verfügbar"
                                        v-if="absencetypesavailable.special_leave > 2"
                                        class="material-symbols-outlined"> info </span>
                                </div>

                                <div
                                    :class="{'notavailable': absencetypesavailable.flextime > 480 || absencetypesavailable.vacationdays > 0.5}" v-if="show_unpaid">
                                    <button class="btn" id="btnUnpaidVacation"
                                        :class="{'active': selectedAbsenceType == 'unpaid', 'notavailable': absencetypesavailable.flextime > 480 || absencetypesavailable.vacationdays > 0.5}"
                                        :disabled="absencetypesavailable.flextime > 480 || absencetypesavailable.vacationdays > 0.5"
                                        @click.stop="changeVacationType('unpaid')">
                                        <span class="material-symbols-outlined"> money_off </span>
                                    </button>
                                    <span class="vacation-name">Unbezahlter Urlaub</span>
                                    <span v-tooltip
                                        title="Nur möglich nach der Planung aller Urlaubstage(bis auf 0.5T) und bei nicht vorhandenem AZK Anspruch!"
                                        v-if="absencetypesavailable.flextime > 480 || absencetypesavailable.vacationdays > 0.5"
                                        class="material-symbols-outlined"> info </span>
                                </div>

                                <div v-if="absencetypesavailable.flextimepossible"
                                    :class="{'notavailable': absencetypesavailable.flextime < 240 + absencetypesavailable.flextimerequestlimit || (!absencetypesavailable.flextime_fullday_possible.all && !absencetypesavailable.flextime_halfday_possible.all)}">
                                    <button class="btn" id="btnFlextimeVacation"
                                        :class="{'active': selectedAbsenceType == 'flextime', 'notavailable': absencetypesavailable.flextime < 240 + absencetypesavailable.flextimerequestlimit || (!absencetypesavailable.flextime_fullday_possible.all && !absencetypesavailable.flextime_halfday_possible.all)}"
                                        :disabled="absencetypesavailable.flextime < 240 + absencetypesavailable.flextimerequestlimit || (!absencetypesavailable.flextime_fullday_possible.all && !absencetypesavailable.flextime_halfday_possible.all)"
                                        @click.stop="changeVacationType('flextime')">
                                        <span class="material-symbols-outlined"> schedule </span>
                                    </button>
                                    <span class="vacation-name">AZK-Ausgleich</span>
                                    <span v-tooltip
                                        :title="Math.floor(absencetypesavailable.flextime / 60) + ' ' + $trans.get('__JSON__.hours available')"
                                        v-if="absencetypesavailable.flextime < 240 + absencetypesavailable.flextimerequestlimit || (!absencetypesavailable.flextime_fullday_possible.all && !absencetypesavailable.flextime_halfday_possible.all)"
                                        class="material-symbols-outlined"> info </span>
                                </div>
                            </div>
                            <div class="col-4 vacation-request-date-select" v-if="step > 2"
                                :class="{'mt-5': switch_years != 'off'}">
                                <h3>Auswahl Zeitraum</h3>
                                <div class="d-block mt-2" v-if="VacationPeriodConstraintError">
                                    <strong>{{ VacationPeriodConstraintError }}</strong>
                                </div>
                                <div class="form-inline vacation-wizard-date-select mt-3">
                                    <label for="datepickerstart">Anfang</label>
                                    <input type="date" max="9999-12-31" min="2024-01-01" v-model="start_at"
                                        id="datepickerstart" @focus="setLastDatepicker('start')" name="start_at"
                                        autocomplete="off" class="form-control">
                                </div>
                                <div class="form-inline vacation-wizard-date-select mt-3">
                                    <label for="datepickerend" class="mt-1 ml-3">Ende</label>
                                    <input type="date" max="9999-12-31" min="2024-01-01" v-model="end_at"
                                        id="datepickerend" @focus="setLastDatepicker('end')" name="end_at"
                                        autocomplete="off" class="form-control" :disabled="half_day">
                                </div>
                                <div class="col m-0 p-0 form-inline switch-halffullday">
                                    <div>
                                        <span @click="setFullDay">Ganzer Tag</span>
                                    </div>
                                    <div class="form-check form-switch form-inline">
                                        <input @click="toggleFullDay" class="form-check-input" type="checkbox"
                                            role="switch" id="halfDaySwitch" v-model="half_day">
                                        <label class="form-check-label" @click="setHalfDay">Halber Tag</label>
                                    </div>
                                </div>
                                <div v-if="half_day" class="col m-0 p-0 form-inline switch-halffullday">
                                    <div>
                                        <span>erste Hälfte</span>
                                    </div>
                                    <div class="form-check form-switch form-inline">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            id="secondHalfSwitch" v-model="second_half">
                                        <label class="form-check-label">zweite Hälfte</label>
                                    </div>
                                </div>
                                <div class="d-block mt-2" v-if="availableDaysReceived">
                                    Mögliche Tage zu diesem Zeitpunkt im Jahr: {{ vacationEntitlement.days }}
                                </div>
                                <label for="comment" class="h3 mt-3">Kommentar</label>
                                <textarea rows="2" class="form-control" name="comment" id="comment"
                                    v-model="comment"></textarea>
                            </div>
                            <div class="col-5 vacation-wizard-explanations" v-if="step > 2"
                                :class="{'mt-5': switch_years != 'off'}">
                                <div class="row">
                                    <div v-if="selectedAbsenceType == 'vacation'">
                                        <div class="card shadow col-11">
                                            <div class="card-body">
                                                <my-vacation-year :employee_id="employee.id" :year="year + ''" />
                                            </div>
                                        </div>
                                        <!-- <div class="row" v-if="vacationdata && vacationdata.afterContractDays > 0"> -->
                                            <!-- <div class="col-10 pe-0 pt-2"> -->
                                                <div class="card shadow col-11 mt-2" v-if="vacationdata && vacationdata.afterContractDays > 0">
                                                    <div class="card-body">
                                                        <my-vacation-year-additional-infos :vacationdata="vacationdata"
                                                            :employee="employee" />
                                                    </div>
                                                </div>
                                            <!-- </div> -->
                                        <!-- </div> -->
                                    </div>
                                    <div v-if="selectedAbsenceType == 'special_leave'">
                                        <h3>Informationen zum Sonderurlaub</h3>
                                        <small>
                                            <ul>
                                                <li>Hochzeit von Kindern: 1 Tag</li>
                                                <li>Todesfall von angehörige (Kindern, Geschwistern, Großeltern und
                                                    Schwiegereltern): 1 Tag</li>
                                                <li>Bei Wohnungswechsel: 1 Tag</li>
                                                <li>Bei Ablegen von Prüfungen im ausgeübten Beruf: 1 Tag</li>
                                                <li>Bei eigener Hochzeit: 2 Tage</li>
                                                <li>Bei Niederkunft der Ehefrau: 2 Tage</li>
                                                <li>Bei Todesfall der Eltern: 2 Tage</li>
                                                <li>Bei Todesfall der/des Ehefrau/Ehegatten: 3 Tage</li>
                                            </ul>
                                        </small>
                                    </div>
                                    <div
                                        v-if="absencetypesavailable.flextimepossible && selectedAbsenceType == 'flextime'">
                                        <h3>Informationen zum Arbeitszeitausgleich</h3>
                                        <!-- {{ employee.flextimeprofile[0].full_days_per_year }} full days -->
                                        <small>
                                            {{ Math.floor(absencetypesavailable.flextime / 60) + ' ' +
                                            $trans.get('__JSON__.hours available') }}<br><br><span
                                                v-if="!employee.flextimeprofile[0].full_days_per_month_unlimited && !employee.flextimeprofile[0].full_days_per_year">Es
                                                können max. {{ employee.flextimeprofile[0].full_days_per_month ?? '#NV'
                                                }} ganze und {{ employee.flextimeprofile[0].half_days_per_month ??
                                                '#NV'}} halbe Tage im Monat,<br>sowie max. {{
                                                employee.flextimeprofile[0].full_days_per_year ?? '#NV'}} ganze und {{
                                                employee.flextimeprofile[0].half_days_per_year ?? '#NV' }} halbe Tage im
                                                Jahr genommen werden.</span>
                                        </small>
                                    </div>
                                    <div v-if="selectedAbsenceType == 'unpaid'">
                                        <h3>Informationen zum unbezahltem Urlaub</h3>
                                        <small>
                                            Nur möglich nach der Planung aller Urlaubstage(bis auf 0.5T) und bei nicht
                                            vorhandenem AZK Anspruch!
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 vacationrequestselection">
                            </div>
                            <div class="col-4">
                                <button v-if="step > 3" @click.stop="sendVacationRequest" :disabled="disabledButtons"
                                    class="d-inline btn btn-s btn-primary me-0 mt-2 float-end">Beantragen</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="false" class="card shadow">
        <div v-if="true">
            {{ vacationEntitlement }}
            <br>
            {{ vacationdata }}
        </div>

    </div>
    <div class="row mb-3">
        <div class="col">
            <div class="card shadow">
                <div class="card-body">
                    <employee-calendar :employee_id="employee_id" :start_year="cal_year" start_month="1" paging="off"
                        switch_years="off" @daySelection="daySelected" journallink="off" :key="reloadKey"
                        :user="user" />
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div v-if="employee" class="modal" tabindex="-1" id="confirmation">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1>{{ $trans.get('__JSON__.Vacation requested') }}!</h1>
                    </div>
                    <div class="modal-body" v-if="this.employee.most_recent_contract && this.employee.most_recent_contract.end_at != null && parseDate(this.employee.most_recent_contract.end_at) < parseDate(this.start_at)">
                        <p class="mb-0">{{ $trans.get('__JSON__.Please note that the requested vacation period falls outside the fixed-term period of your current employment contract') }}.</p>
                        <br>
                        <p class="mb-0">{{ $trans.get('__JSON__.For this reason, approval of your vacation request is currently not possible') }}.</p>
                        <br>
                        <p class="mb-0">{{ $trans.get('__JSON__.If you have any questions, your direct supervisor will be happy to assist you during the relevant shift hours') }}.</p>
                    </div>
                    <div class="modal-body" v-else>
                        <p class="mb-0">{{ $trans.get('__JSON__.Your vacation has been requested') }}.</p>
                        <p class="mb-0">{{ $trans.get('__JSON__.We will send an email when it has been processed') }}.</p>
                        <br>
                        <p class="mb-0">{{ $trans.get('__JSON__.If you have not supplied an email address, you have to check back here to see the status of your request') }}.</p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="dismissConfirmation">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import axios from "axios";
import WizardSteps from "./WizardSteps.vue";
import { inAllowedTimeframe } from "../checkdate";
import { DateTime } from "luxon";
import { error } from "jquery";
import { luxonParseDate } from "../transformDate"; 

export default {
  name: "VacationRequest",
  props: {
    employee_id: String,
    show_year: String,
    switch_years: String,
    user: Object,
    show_unpaid: true,
  },
  components: {
    WizardSteps,
  },
  data() {
    return {
        employee: null,
        errors: null,
        step: '',
        year: null,
        start_at: null,
        end_at: null,
        selectedAbsenceType: null,
        comment: null,
        unpaid: false,
        from_flextime: false,
        half_day: false,
        second_half: false,
        special_leave: false,
        last_datepicker: null,
        vacation_data: null,
        absencetypesavailable: null,
        disabledButtons: false,
        reloadKey: 0,
        cal_year: null,
        year_switch: null,
        onlyFullDay: null,
        onlyHalfDay: null,
        vacationEntitlement: null,
        availableDaysReceived: false,
        VacationPeriodConstraintError: null,
    };
  },
  watch: {
    year_switch: function() {
        if (!this.year_switch) {
            this.year = this.show_year;
        } else {
            this.year = parseInt(this.show_year) + 1;
        }
        this.reloadKey++;
        var date = new Date();
        this.cal_year = this.year ? this.year : date.getFullYear();
        this.getAbsenceTypesAvailable();
        this.selectedAbsenceType = null;
    },
    selectedAbsenceType: function() {
        this.start_at = null;
        this.end_at = null;
        this.unpaid = false;
        this.from_flextime = false;
        this.special_leave = false;
        this.last_datepicker = null;
        this.availableDaysReceived = false;
        this.VacationPeriodConstraintError = null;

        if (this.selectedAbsenceType == 'special_leave') {
            this.special_leave = true;
        } else if (this.selectedAbsenceType == 'flextime') {
            this.from_flextime = true;
        } else if (this.selectedAbsenceType == 'unpaid') {
            this.unpaid = true;
        }
        this.toggleFullDay();
        this.checkStep();
    },
     start_at: function() {
        this.getVacationEntitlement();
         this.checkStep(true);
     },
     end_at: function() {
        this.getVacationEntitlement();
     },
    half_day: function() {
        if (this.half_day) {
            this.end_at = null;
        }
    }
  },
  created() {
    this.reloadKey++;
    this.year = this.show_year;
    this.cal_year = this.year;
    this.getEmployee();
    this.getVacationData();
    this.getAbsenceTypesAvailable();
    this.checkStep();
  },
  methods: {
    checkVacationPeriodConstraints() {
        
        let startDate = DateTime.fromFormat(this.start_at,'yyyy-MM-dd');
        let endDate = DateTime.fromFormat(this.end_at, 'yyyy-MM-dd');
        let actualDate = DateTime.now().startOf('day');
        // check if start date is in past, if so, cancel
        if (startDate < actualDate) {
            this.VacationPeriodConstraintError = this.$trans.get('__JSON__.Vacation period must atleast start today!');
            this.start_at = null;
            return error;
        }
        //check if end_at is in other year than start_at
        if(startDate.get('year') != endDate.get('year') ) {
            this.end_at = null;
            this.VacationPeriodConstraintError = this.$trans.get('__JSON__.Vacation period must be in the same year!');
            return error;
        }
        // check if request year matches selected year 
        if (this.cal_year != startDate.get('year')) {
            this.VacationPeriodConstraintError = this.$trans.get('__JSON__.Vacation period must be in the selected year!') + ' ' + this.cal_year;
            this.start_at = null;
            this.end_at = null;
            return error;
        }
    },
    setStartYear() {
        this.year_switch = false;
    },
    getAbsenceTypesAvailable() {
        if (this.year || this.switch_years == 'off') {
            axios
                .get("/api/employees/" + this.employee_id + "/absencetypesavailable", {
                    params: {
                        year: this.year
                    }
                })
                .then((resp) => {
                    this.absencetypesavailable = resp.data;
                    this.step = 2;
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                });
        }
    },
    getFlextimeProfile() {
        if (this.year || this.switch_years == 'off') {
            axios
                .get("/api/employees/" + this.employee_id + "/absencetypesavailable", {
                    params: {
                        year: this.year
                    }
                })
                .then((resp) => {
                    this.absencetypesavailable = resp.data;
                    this.step = 2;
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                });
        }
    },
    toggleFullDay() {
        if (this.selectedAbsenceType == 'special_leave' || this.selectedAbsenceType == 'unpaid') {
            this.half_day = false;
            this.onlyFullDay = true;
            this.onlyHalfDay = false;
            this.second_half = false;
            return;
        }
        if (this.selectedAbsenceType == 'flextime') {
            if (this.half_day) {
                if (this.absencetypesavailable.flextime_fullday_possible.all) {
                    this.half_day = false;
                    this.second_half = false;
                } else {
                    this.half_day = true;
                }
            } else if (!this.half_day) {
                if (this.absencetypesavailable.flextime_halfday_possible.all) {
                    this.half_day = true;
                } else {
                    this.half_day = false;
                    this.second_half = false;
                }
            }
            this.onlyFullDay = true;
            this.onlyHalfDay = true;
            if (this.absencetypesavailable.flextime_halfday_possible.all) {
                this.onlyHalfDay = false;
                this.second_half = false;
            }
            if (this.absencetypesavailable.flextime_fullday_possible.all) {
                this.onlyFullDay = false;
            }
            return;
        }
        if (this.selectedAbsenceType == 'vacation') {
            if (this.absencetypesavailable.vacationdays > 0.5) {
                this.half_day = false;
                this.second_half = false;
                this.onlyHalfDay = false;
                this.onlyFullDay = false;
            }
            return;
        }
    },
    getEmployee() {
        axios
            .get("/api/employees/" + this.employee_id)
            .then((resp) => {
                this.employee = resp.data;
            })
            .catch((error) => {
                this.errors = error.response.data.errors;
            });
    },
    checkStep(dateCheck = false) {
        if (!dateCheck) {
            if (this.switch_years == 'on') {
                this.step = 1; //year selection
            } else {
                this.year = this.show_year;
            }
            if (this.year && !this.step == 2) {
                this.getAbsenceTypesAvailable()
            }
            if (this.selectedAbsenceType) {
                this.step = 3; //pick start at
            }
        } else {
            if (this.start_at) {
                this.getVacationEntitlement();
                this.step = 4;
            }
        }
    },
    getVacationEntitlement() {
        var queryDate = this.end_at;

        if (!queryDate) {
            queryDate = this.start_at;
        }
        //console.log('queryDate', queryDate);

        axios
            .get("/api/employees/" + this.employee_id + "/projectedvacationentitelementforyear", {
                params: {
                    start_at: queryDate,
                    till_end_of_year: 1
                }
            })
            .then((resp) => {
                if (resp.data) {
                    this.vacationEntitlement = resp.data;
                    this.availableDaysReceived = true;
                }
            })
            .catch((error) => {
                this.errors = error.response.data.errors;
            });
    },
      sendVacationRequest() {

        this.errors = null;
        this.VacationPeriodConstraintError = null;

        if (!this.end_at) {
            this.end_at = this.start_at;
        }

        this.checkVacationPeriodConstraints();

        if(this.checkVacationPeriodConstraints == 'error') {
            return;
        }

        if (!inAllowedTimeframe(3, 24, this.start_at, this.end_at)) {
            this.disabledButtons = false;
            return; 
        }

        this.disabledButtons = true;

        const absence = {
            employee_id: this.employee.id,
            start_at: this.start_at,
            end_at: this.end_at,
            half_day: this.half_day,
            second_half: this.second_half,
            granted: false,
            absence_type_id: 2,
            from_flextime: this.from_flextime,
            unpaid: this.unpaid,
            special_leave: this.special_leave,
            request_comment: this.comment,
            year: this.year,
        };

        //console.log('sending absence request', absence);
        axios
            .post("/api/absences", absence)
            .then((resp) => {
                $('#confirmation').modal('show');
            })
            .catch((error) => {
                this.errors = error.response.data.errors;
                this.disabledButtons = false;
            });
    },
    setLastDatepicker(latest) {
        this.last_datepicker = latest;
    },
    daySelected(day) {
        if (this.selectedAbsenceType) {
            if (this.last_datepicker == 'start') {
                this.start_at = day.getFullYear() + '-' + this.pad(day.getMonth() + 1, 2) + '-' + this.pad(day.getDate(), 2);
                this.end_at = null;
            } else if (this.last_datepicker == 'end') {
                this.end_at = day.getFullYear() + '-' + this.pad(day.getMonth() + 1, 2) + '-' + this.pad(day.getDate(), 2);
            } else {
                if (!this.start_at) {
                    this.start_at = day.getFullYear() + '-' + this.pad(day.getMonth() + 1, 2) + '-' + this.pad(day.getDate(), 2);
                    this.end_at = null;
                } else if (!this.end_at && !this.half_day) {
                    this.end_at = day.getFullYear() + '-' + this.pad(day.getMonth() + 1, 2) + '-' + this.pad(day.getDate(), 2);
                }
            }
        }
    },
    pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    },
    dismissConfirmation() {
        $('#confirmation').modal('hide');
        window.location.href = '/my/home';
    },
    getVacationData() {
        axios
            .get("/api/employees/" + this.employee_id + '/vacationdata')
            .then((resp) => {
                this.vacationdata = resp.data;
            })
            .catch((error) => {
                this.errors = error.response.data.errors;
            });

    },
    changeVacationType(type) {
        this.selectedAbsenceType = type;
    },
    setFullDay() {
        this.toggleFullDay();
    },
    setHalfDay() {
        this.toggleFullDay();
    },
    parseDate(date) {
        return luxonParseDate(date);
    },
    },
};

</script>
